import type {ReactElement} from 'react';
import VideoPreview from '@Components/video-preview-new';
import styles from './ai-chat-assets-video-tile.module.scss';
import type {AiChatAssetsVideoTileProps} from './ai-chat-assets-video-tile.types';
import {getUrlForAiChatAnimation, getUrlForAiChatAnimationThumbnail} from '@Libraries/ai-chat.library';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {useAiChat} from '@/ai-chat/providers/ai-chat.context';

export function AiChatAssetsVideoTile({asset}: AiChatAssetsVideoTileProps): ReactElement {
  const {state} = useAiChat();

  const getPlayIconSize = (): IconSize => {
    if (state.isSmall) {
      return IconSize.SIZE_ICON_16;
    }

    return IconSize.SIZE_ICON_20;
  };

  return (
    <div className={styles.videoTile}>
      <VideoPreview
        imgPlaceHolderSrc={getUrlForAiChatAnimationThumbnail(asset.assetHashedFilename)}
        videoSrc={getUrlForAiChatAnimation(asset.assetHashedFilename)}
        duration={asset.duration ?? undefined}
        showDurationTag={false}
        showVideoPreview={false}
      />
      <div className={styles.gradientOverlay} aria-hidden />
      <div className={styles.playBadge} aria-hidden>
        <Icon icon="icon-play-video" className="content-body-white" size={getPlayIconSize()} />
      </div>
    </div>
  );
}
